import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 disabled:pointer-events-none disabled:opacity-50 active:scale-95 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary:
          "bg-blue-600 text-white shadow-md hover:bg-blue-700",
        secondary:
          "bg-slate-200 text-slate-900 border border-slate-300 shadow-sm hover:bg-slate-300",
        danger:
          "bg-red-600 text-white shadow-md hover:bg-red-700",
        success:
          "bg-green-600 text-white shadow-md hover:bg-green-700",
        ghost: 
          "hover:bg-slate-100 hover:text-slate-900",
        link: 
          "text-blue-600 underline-offset-4 hover:underline",
        // Mantener default para compatibilidad
        default:
          "bg-blue-600 text-white shadow-md hover:bg-blue-700",
        destructive:
          "bg-red-600 text-white shadow-md hover:bg-red-700",
        outline:
          "border-2 border-slate-300 bg-white shadow-sm hover:bg-slate-50",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-12 px-6 text-base",
        icon: "h-10 w-10",
        "icon-sm": "h-8 w-8",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
